import { ContentSection, Heading } from '@cinch-labs/design-system'
import { StoryBlokRichText, StoryblokImage } from '@cinch-nx/data-storyblok'

import CarouselWithHeadingAndText from '../../carousel-with-heading-and-text/carousel-with-heading-and-text'
import renderWithResolver from '../../rich-text-renderer/rich-text-renderer'
import { LifeShineLogo } from './assets'
import styles from './lifeshine.module.css'

export interface LifeshineProps {
  title: string
  body: StoryBlokRichText
  mobileSubHeading: string
  carouselSlides: LifeshineSlideProps[]
}

export interface LifeshineSlideProps {
  heading: string
  body: string
  image: StoryblokImage
}

export const Lifeshine: React.FC<LifeshineProps> = ({
  title,
  body,
  mobileSubHeading,
  carouselSlides,
}) => (
  <div className={styles.componentWrapper} data-testid="lifeshine">
    <div className={styles.textWrapper}>
      <LifeShineLogo id="lifeshineLogo" className={styles.lifeshineLogo} />
      <Heading className={styles.heading}>{title}</Heading>
      <div className={styles.body}>
        <ContentSection classNames={{ body: styles.richTextBody }}>
          {renderWithResolver(body)}
        </ContentSection>
      </div>

      <Heading
        data-testid="lifeshineMobileText"
        className={styles.lifeshineMobileTextWrapper}
      >
        {mobileSubHeading}
      </Heading>
    </div>

    <div className={styles.carouselWrapper}>
      <CarouselWithHeadingAndText
        name="lifeshine"
        carouselSlides={carouselSlides}
      />
    </div>
  </div>
)

export default Lifeshine
